export const calcDailyBudget = (
  monthlyBudget?: number,
  days?: number
) => {
  if (!monthlyBudget || !days || days === 0) return undefined;
  return Math.floor(monthlyBudget / days);
};

const toMonthStartDate = (period?: string) => {
  if (!period) return null;

  const normalized = period.length >= 10 ? period.slice(0, 10) : `${period}-01`;
  const date = new Date(`${normalized}T00:00:00`);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const normalizeBudgetPeriod = (period?: string) => {
  const date = toMonthStartDate(period);
  if (!date) return '';

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  return `${year}-${month}`;
};

export const getDaysInBudgetMonth = (period?: string) => {
  const date = toMonthStartDate(period);
  if (!date) return 0;

  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

export const formatBudgetPeriodLabel = (period?: string) => {
  const normalized = normalizeBudgetPeriod(period);
  if (!normalized) return '';

  const [year, month] = normalized.split('-');
  return `${year}年${Number(month)}月`;
};

export const formatBudgetDateRange = (period?: string, days?: number) => {
  const normalized = normalizeBudgetPeriod(period);
  const totalDays = days ?? getDaysInBudgetMonth(period);

  if (!normalized || totalDays <= 0) return '';

  const [year, month] = normalized.split('-');
  return `${year}年${Number(month)}月1日〜${totalDays}日`;
};

export const getBudgetMonthKey = (monthOffset = 0, baseDate = new Date()) => {
  const date = new Date(baseDate.getFullYear(), baseDate.getMonth() + monthOffset, 1);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');

  return `${year}-${month}`;
};

export const getBudgetPeriodStatus = (period: string, baseDate = new Date()) => {
  const target = normalizeBudgetPeriod(period);
  const current = getBudgetMonthKey(0, baseDate);

  if (target > current) return 'next';
  if (target < current) return 'past';
  return 'current';
};

export const shiftBudgetPeriod = (period?: string, monthOffset = 0) => {
  const normalized = normalizeBudgetPeriod(period);
  if (!normalized) return '';

  const [year, month] = normalized.split('-').map(Number);
  const shifted = new Date(year, month - 1 + monthOffset, 1);

  return normalizeBudgetPeriod(`${shifted.getFullYear()}-${`${shifted.getMonth() + 1}`.padStart(2, '0')}`);
};
